"use strict";

exports.__esModule = true;
exports.AggregateMetricChart = void 0;
var _react = _interopRequireDefault(require("react"));
var _ChartCard = require("../common/ChartCard");
var _reactIntl = require("react-intl");
var _AggregateMetricChartElement = require("./AggregateMetricChartElement");
var _AggregateMetricChartFields = require("./AggregateMetricChartFields");
var _AggregateMetricChartThumbnail = require("./AggregateMetricChartThumbnail");
var _widgetGroups = require("../widgetGroups");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var AggregateMetricChart = exports.AggregateMetricChart = {
  name: "AggregateMetricChart",
  label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "AggregateMetricChartWidget.label",
    defaultMessage: "Aggregate Metric Chart"
  }),
  icon: "th-list",
  group: _widgetGroups.METRIC_WIDGET,
  createElement: function createElement(props) {
    return {
      type: "AggregateMetricChart",
      props: Object.assign({
        width: 512,
        height: 512,
        aggregations: [],
        filters: [],
        metricChartSeries: [{
          metricName: "utilization",
          seriesType: "bar"
        }],
        hideXAxis: false,
        hideXUnits: false,
        hideYAxis: false,
        showLegends: true,
        showChartTooltip: true
      }, props),
      children: []
    };
  },
  showInPalette: true,
  isParent: true,
  requiresContexts: [],
  suppliesContexts: [],
  optionalProps: ["fontFamily", "fontSize", "fontWeight", "fontStyle", "textDecoration", "textAlignment", "color", "onClickAction"],
  requiresProps: ["x", "y", "width", "height"],
  suppliesProps: [],
  propConstraints: {
    width: {
      "default": 256,
      min: 32,
      max: 3840
    },
    height: {
      "default": 64,
      min: 32,
      max: 2160
    }
  },
  components: {
    Element: (0, _ChartCard.withChartCard)(_AggregateMetricChartElement.AggregateMetricChartElement, function () {
      return {
        title: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
          id: "AggregateMetricChartWidget.card.title",
          defaultMessage: "Metrics"
        })
      };
    }),
    Fields: _AggregateMetricChartFields.AggregateMetricChartFields,
    Thumbnail: _AggregateMetricChartThumbnail.AggregateMetricChartThumbnail
  }
};